{
  "meta": {
    "title":       "Hakkımızda | GlobalAnka",
    "description": "GlobalAnka'nın hikayesi, değerleri ve küresel ekibi. 2015'ten bu yana uluslararası iş gücü yönetiminde mükemmellik."
  },
  "hero": {
    "label":        "Hakkımızda",
    "titleStart":   "Küresel Ölçekte,",
    "titleAccent":  "Yerel Uzmanlıkla",
    "subtitle":     "2015'ten bu yana uluslararası iş gücü yönetimi ve kurumsal danışmanlıkta güvenilir çözüm ortağınız. İŞKUR lisanslı, dürüst ve sonuç odaklı.",
    "cta":          "İletişime Geçin",
    "ctaPath":      "/contact"
  },
  "vision": {
    "sectionLabel": "Vizyonumuz",
    "title":        "Uluslararası Prestijin Yeni Tanımı",
    "body":         "2030'a kadar Türkiye'nin en büyük ve en saygın uluslararası iş gücü ve danışmanlık markası olmak; her hizmetimizde kurumsal mükemmelliği standart haline getirmek."
  },
  "mission": {
    "sectionLabel": "Misyonumuz",
    "title":        "Sınırları Kaldıran Çözümler",
    "body":         "Müşterilerimizin küresel büyüme hedeflerine ulaşmalarını sağlamak için doğru yeteneği, doğru zamanda, en yüksek etik standartlarla sunmak."
  },
  "values": {
    "sectionLabel": "Temel Değerlerimiz",
    "sectionTitle": "Bizi GlobalAnka Yapan İlkeler",
    "integrity": {
      "title": "Dürüstlük & Şeffaflık",
      "desc":  "Tüm operasyonlarımızda yasal uyumluluk ve şeffaf iletişim temel ilkemizdir. İŞKUR lisansımız bu taahhüdün resmi güvencesidir."
    },
    "global": {
      "title": "Küresel Vizyon",
      "desc":  "40+ ülkede aktif bağlantılarımızla müşterilerimize yerel bilgi ve uluslararası ağın eşsiz kombinasyonunu sunuyoruz."
    },
    "people": {
      "title": "İnsan Odaklılık",
      "desc":  "Sadece pozisyon doldurmuyoruz; kurumsal kültürünüze uygun, uzun vadeli iş ortaklıkları kuruyoruz."
    },
    "solutions": {
      "title": "Çözüm Üretme",
      "desc":  "48 saat içinde ön teklif, 72 saatte aday profili sunma garantimizle sektörün en hızlı tepki sürelerini sunuyoruz."
    },
    "excellence": {
      "title": "Mükemmellik",
      "desc":  "Her projede en yüksek kalite standartlarını hedefliyor, sonuçları ölçülebilir metriklerle raporluyoruz."
    },
    "sustainability": {
      "title": "Sürdürülebilirlik",
      "desc":  "ESG ilkelerine bağlı, çevre ve toplum dostu iş modelleri ile kurumsal değer yaratıyoruz."
    }
  },
  "timeline": {
    "sectionLabel": "Tarihçemiz",
    "sectionTitle": "Milat Noktalarımız",
    "2015": { "title": "Kuruluş",             "desc": "İstanbul'da 3 kişilik ekiple uluslararası işe alım alanında faaliyete başladık." },
    "2017": { "title": "İŞKUR Lisansı",       "desc": "4904 sayılı Kanun kapsamında özel istihdam bürosu olarak resmi lisansımızı aldık." },
    "2019": { "title": "Bölgesel Genişleme",  "desc": "Orta Asya ve Körfez ülkelerinde temsilcilik ve partner ağımızı kurduk." },
    "2022": { "title": "GlobalAnka Akademi",  "desc": "Sertifikalı teknik kadro yetiştirme programımız devreye girdi." },
    "2024": { "title": "Dijital Dönüşüm",     "desc": "Yapay zeka destekli aday eşleştirme platformumuzu hayata geçirdik." }
  },
  "whyList": [
    "Küresel yetenek ağı — 40+ ülkede aktif bağlantılar",
    "İŞKUR lisanslı, %100 yasal uyumluluk garantisi",
    "Senior danışman atamanız 72 saatten kısa sürede",
    "7/24 müşteri başarı ekibi desteği"
  ]
}
